import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 24px 24px 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.h2`
  margin: 0;
  color: #212121;
  font-size: 24px;
  line-height: 1.2;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 1000px) {
    grid-template-columns: 5fr 7fr;
  }
`;

export const ColumnCard = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HelperText = styled.p`
  margin: 0;
  color: #757575;
  font-size: 13px;
`;

export const SectionBlock = styled.div`
  width: 100%;
  margin-top: 8px;
`;

export const SectionTitle = styled.strong`
  display: block;
  width: 100%;
  margin-bottom: 4px;
  color: #424242;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const SectionHint = styled.p`
  width: 100%;
  margin: 0 0 8px;
  color: #757575;
  font-size: 13px;
`;

export const DaysGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
`;
